import { Body } from './Body';

export default function NotAFit() {
  return <Body title={`Hmm, looks like you aren't a fit for this project, but we will keep you posted on future opportunities.`} />;
}

export { NotAFit };